import {eatalianoAxios} from "@/data/api/http/axios";
import {DayReport} from "@/data/entities/dayReport";

/**
 * Financial report of the restaurant on a day (default: today): revenue
 * (gross, net, VAT), worked hours, order counts and the online payments to
 * refund via Mollie. Admins only.
 */
export const getDayReport = (restaurantId: number, date?: string): Promise<DayReport> => (
    eatalianoAxios
        .get<DayReport>(`/admin/reports/${restaurantId}/day`, {params: {date}})
        .then(response => response.data)
);